import { animateScroll as scroll } from "react-scroll";

const scrollToTop = () => {
	scroll.scrollToTop({ containerId: "main-container" });
};

export default scrollToTop;
